import React, { useState, useRef } from 'react';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';

// --- Firebase (คงตามเดิม) ---
const firebaseConfig = {
  apiKey: "AIzaSyBALO-oNqvxmRhTSx9S54A5PIilTrxVOYM",
  authDomain: "refinery-desk-dashboard.firebaseapp.com",
  projectId: "refinery-desk-dashboard",
  storageBucket: "refinery-desk-dashboard.firebasestorage.app",
  messagingSenderId: "28035012838",
  appId: "1:28035012838:web:eb80f171a10371cdbec327"
};
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// ----------------------------------------------------
// Practical Shortcut (cleaned)
// - การ์ด: Title + Caption + ปุ่ม Send
// - Preview ก่อนส่ง (ไม่มีฟอร์มคอนเฟิร์มคิว/แก้คิวอีกแล้ว)
// ----------------------------------------------------
const SHEET_TITLE = 'Frequency Asked Question (Oligio)';

// ✅ กำหนดไอดีการ์ดที่ผูกกับโมดัล (เพิ่มได้ในอนาคต)
const OLIGIOCALMODAL = 'OLIGIO-CAL';

const SHORTCUTS = [
  { id: OLIGIOCALMODAL, title: 'Oligio x Ultraformer', caption: 'สรุปราคา Oligio [Bundle]', content: '' },
  {
    id: 'oligio-what',
    title: 'What is Oligio?',
    caption: 'Monopolar RF',
    content:
      'Oligio คือเทคโนโลยียกกระชับผิวด้วยพลังงาน Monopolar RF ช่วยกระตุ้นคอลลาเจน ล็อกกรอบหน้า และลดไขมันสะสมเล็กน้อยอย่างนุ่มนวล เหมาะกับคนที่ต้องการความเป็นธรรมชาติ โดยไม่ต้องพักฟื้นยาวนะคะ'
  },
  {
    id: 'oligio-who',
    title: 'Oligio suitable for?',
    caption: 'Oligio เหมาะกับใคร?',
    content:
      'Oligio จะเหมาะสำหรับผู้ที่เริ่มมีผิวหย่อนคล้อย ริ้วรอยตื้น ๆ กรอบหน้าไม่คม\n\nรวมถึงรูขุมขนกว้าง ต้องการคุณภาพผิวแน่นฟูขึ้น\n\nและต้องการยกกระชับแบบไม่ผ่าตัด ผลลัพธ์เป็นธรรมชาติค่ะ'
  },
  {
    id: 'oligio-areas',
    title: 'Oligio Area?',
    caption: 'อธิบายบริเวณที่ทำได้',
    content:
      'Oligio ได้สองตำแหน่งนี้ค่ะ\n\nบริเวณใบหน้า: กรอบหน้า แก้ม ร่องแก้ม เหนียง/คางสองชั้น\n\nบริเวณรอบดวงตา: หัวยิงขนาดเล็กเฉพาะดวงตา ช่วยให้ผิวรอบตาดูกระชับขึ้น'
  },
  {
    id: 'oligio-time-pain',
    title: 'Oligio Time',
    caption: 'ส่งระยะเวลาการทำ',
    content:
      'โดยปกติ Oligio จะใช้ระยะเวลาทำเฉลี่ย 20–30 นาที/ครั้ง (แล้วแต่บริเวณ) ค่ะ\n\nความรู้สึกระหว่างทำเป็นอุ่น ๆ เล็กน้อยนะคะ'
  },
  {
    id: 'oligio-result',
    title: 'Oligio Result',
    caption: 'อธิบายระยะเห็นผล',
    content:
      'หลังทำเห็นผิวตึงขึ้นทันทีประมาณ ~20% ค่ะ\n\nโดยคอลลาเจนที่ถูกกระตุ้นจะชัดขึ้นเรื่อย ๆ ใน 3–6 เดือน\n\nและผลลัพธ์โดยทั่วไปคงอยู่โดยเฉลี่ยราว ~6–8 เดือน ค่ะ'
  },
  {
    id: 'oligio-combo',
    title: 'Oligio Combo',
    caption: 'ทำคู่กับอะไรแล้วเวิร์ก',
    content:
      'ทั้ง Oligio และ Ultraformer มีจุดมุ่งหมายในการยกกระชับผิว แต่ลงลึกคนละชั้น ซึ่งทั้งสองสามารถทำคู่กันได้ โดยจะช่วยสนุบสนุนผลลัพธ์ซึ่งกันและกันค่ะ'
  },
  {
    id: 'oligio-compare',
    title: 'vs Thermage',
    caption: 'เปรียบเทียบเพิ่มเติม',
    content:
      'ทั้ง Oligio และ Thermage ต่างใช้พลังงาน Monopolar RF ในการยกกระชับผิว แต่แม้จะใช้พลังงานชนิดเดียวกัน จุดต่างอยู่ที่ “รูปแบบ” และ “ประสบการณ์” นะคะ\n\nโดย Thermage จะเจ็บกว่าเล็กน้อย และมีราคาที่สูงกว่า โดยทั้งสองให้ผลลัพธ์ที่ใกล้เคียงกันในการฟื้นฟูผิวและปรับรูปหน้าค่ะ'
  },
];

// ------- LINE / Firestore helpers -------
const logToFirestore = async (text, selectedCustomer) => {
  const latestCustomerInfo = selectedCustomer || {};
  await addDoc(collection(db, 'messages'), {
    from: 'me',
    role: 'me',
    userId: latestCustomerInfo?.userId || '',
    type: 'text',
    customer: text,
    createdAt: serverTimestamp(),
    displayName: latestCustomerInfo.displayName || 'Customer',
    pictureUrl: latestCustomerInfo.pictureUrl || '',
  });
};
const sendToLine = async (userId, text) => {
  const res = await fetch('https://therefineryclinic.herokuapp.com/sendToLine', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, message: text }),
  });
  const result = await res.json();
  if (!result.success) throw new Error(result.error || 'ส่ง LINE ไม่สำเร็จ');
};

export default function MessageShortcut({ userId, selectedCustomer, onBack }) {
  const [successMessage, setSuccessMessage] = useState('');
  const [previewItem, setPreviewItem] = useState(null);
  const [sendingId, setSendingId] = useState(null);

  // 👇 state เปิด/ปิดโมดัล (ขยายเพิ่มทีหลังได้)
  const [showOligioCal, setShowOligioCal] = useState(false);

  const scrollRef = useRef(null);
  const getScrollableParent = (el) => {
    let node = el;
    while (node && node !== document.body) {
      const { overflowY } = window.getComputedStyle(node);
      if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) return node;
      node = node.parentElement;
    }
    return window;
  };
  const scrollToTop = () => {
    const target = getScrollableParent(scrollRef.current);
    (target === window ? window : target).scrollTo({ top: 0, behavior: 'smooth' });
  };

  const sendAndLogText = async (text, idForLock) => {
    try {
      setSendingId(idForLock || 'inline');
      await sendToLine(userId, text);
      await logToFirestore(text, selectedCustomer);
      setSuccessMessage(`ส่งข้อความสำเร็จ:\n${text}`);
      setPreviewItem(null);
      setTimeout(() => setSuccessMessage(''), 1800);
    } catch (err) {
      console.error('❌ LINE ERROR:', err);
      alert('❌ ไม่สามารถส่งข้อความผ่าน LINE ได้');
    } finally {
      setSendingId(null);
    }
  };

  // ✅ ฟังก์ชันเปิดโมดัลตาม id (เพิ่ม case ได้ในอนาคต)
  const openModalById = (id) => {
    switch (id) {
      case OLIGIOCALMODAL:
        setShowOligioCal(true);
        return true;
      default:
        return false;
    }
  };

  const isModalShortcut = (id) => [OLIGIOCALMODAL].includes(id);

  // ------- UI -------
  return (
    <div ref={scrollRef} className="relative max-w-screen-xl mx-auto">
      {/* Header */}
      <div className="flex justify-between items-center mt-[-2px] mb-4">
        <div className="flex items-center gap-3">
          <h3 className="text-lg font-semibold">{SHEET_TITLE}</h3>
          <button
            onClick={onBack}
            className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-500 bg-gray-100 hover:bg-gray-200 transition"
          >
            ← Back
          </button>
        </div>
      </div>

      {/* Grid 3 columns */}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
        {SHORTCUTS.map((item) => (
          <div key={item.id} className="border border-gray-200 rounded-xl p-4 bg-white shadow-sm hover:shadow transition">
            <div className="flex items-start justify-between gap-3">
              {/* Title + Caption (คลิกเพื่อ Preview/Modal) */}
              <button
                type="button"
                onClick={() => {
                  // ถ้าเป็นการ์ดที่ผูกโมดัล ให้เปิดโมดัลแทนการ Preview
                  if (openModalById(item.id)) {
                    setPreviewItem(null);
                  } else {
                    setPreviewItem(item);
                  }
                }}
                className="text-left"
                title="Preview หรือเปิดโมดัล"
                aria-label="Preview หรือเปิดโมดัล"
              >
                <div className="text-sm font-semibold leading-snug">{item.title}</div>
                {item.caption && <div className="text-xs text-gray-500 mt-0.5">{item.caption}</div>}
              </button>

              {/* Quick Send (ซ่อนสำหรับการ์ดที่เป็นโมดัล) */}
              {!isModalShortcut(item.id) && (
                <button
                  type="button"
                  onClick={() => sendAndLogText(item.content, item.id)}
                  disabled={sendingId === item.id}
                  className={`px-3 py-1 text-xs rounded-full border transition ${sendingId === item.id ? 'bg-gray-200 text-gray-400 border-gray-200 cursor-not-allowed' : 'border-gray-300 text-gray-700 hover:bg-gray-100'}`}
                  title="ส่งข้อความนี้ทันที"
                >
                  {sendingId === item.id ? 'Sending…' : 'Send'}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Preview Modal */}
      {previewItem && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl w-[92vw] max-w-[840px] p-5">
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="text-sm font-semibold">{previewItem.title}</div>
                {previewItem.caption && <div className="text-xs text-gray-500">{previewItem.caption}</div>}
              </div>
              <div className="flex items-center gap-2">
                <button onClick={() => setPreviewItem(null)} className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-500 hover:bg-gray-100">✕ Close</button>
              </div>
            </div>

            <div className="mt-4 text-sm text-gray-800 whitespace-pre-line border border-gray-200 rounded-xl p-3 bg-gray-50">{previewItem.content}</div>

            <div className="mt-5 flex items-center justify-end gap-3">
              <button onClick={() => setPreviewItem(null)} className="px-4 py-1 text-sm border border-gray-300 rounded-full text-gray-600 hover:bg-gray-100">Cancel</button>
              <button
                onClick={() => sendAndLogText(previewItem.content, previewItem.id)}
                disabled={sendingId === previewItem.id}
                className={`px-4 py-1 text-sm rounded-full transition ${sendingId === previewItem.id ? 'bg-gray-300 text-white cursor-not-allowed' : 'bg-black text-white hover:opacity-90'}`}
              >
                {sendingId === previewItem.id ? 'Sending…' : 'Send'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ---- Oligio Bundle Modal (เปิดเมื่อกดการ์ด OLIGIOCALMODAL) ---- */}
      {showOligioCal && (
        <OligioCalModal
          onClose={() => setShowOligioCal(false)}
          onSend={async (text) => {
            await sendAndLogText(text, OLIGIOCALMODAL);
            // โมดัลจะปิดเองจาก onClose ภายในโมดัลหลังส่งสำเร็จ (เผื่อกรณี edge)
            setShowOligioCal(false);
          }}
        />
      )}

      {/* Success Alert */}
      {successMessage && (
        <div className="fixed inset-0 flex items-center justify-center z-[90]">
          <div className="bg-white shadow-xl rounded-xl px-6 py-4 border border-gray-200 text-center max-w-sm w-[92vw]">
            <div className="text-sm text-gray-800 mb-3 whitespace-pre-line">{successMessage}</div>
            <button onClick={() => setSuccessMessage('')} className="text-xs px-3 py-1 border border-gray-300 rounded-full hover:bg-gray-100 transition text-gray-500">ปิด</button>
          </div>
        </div>
      )}

      {/* Footer Controls */}
      <div className="mt-6 flex justify-between items-center">
        <button onClick={onBack} className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-500 bg-gray-100 hover:bg-gray-200 transition">← Back</button>
        <button onClick={scrollToTop} className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-500 bg-gray-100 hover:bg-gray-200 transition">↑ Top</button>
      </div>
    </div>
  );
}

/* ============================================================
   Oligio Bundle Calculator (Standalone Modal)
   - ไม่มีกรอกราคา Ultraformer เอง (เลือกตามตาราง ULTRA_BASE)
   - ปุ่ม Copy มีป๊อปอัพในตัวโมดัล
   - ปุ่ม Send → แสดงสถานะ Sending และปิดโมดัลเมื่อส่งสำเร็จ
   - สรุปโชว์ทั้ง 2 กรณีเสมอ (อย่างเดียว / คู่ Ultraformer)
   ============================================================ */
const OLIGIO_NORMAL = {
  100: 5900,
  200: 10900,
  300: 14900,
  400: 18900,
  500: 22900,
  600: 25900,
  800: 33900,
  900: 37900,
  1000: 40900,
  1200: 47900,
  1500: 58900,
};
const OLIGIO_BUNDLE = {
  100: 4590,
  200: 8900,
  300: 11900,
  400: 15900,
  500: 19900,
  600: 23900,
  800: 29900,
  900: 32900,
  1000: 35900,
  1200: 42900,
  1500: 51900,
};
const ULTRA_BASE = {
  100: 3990,
  200: 5990,
  400: 9900,
  600: 13900,
  800: 17900,
  1000: 20900,
};
const baht = (n) => (typeof n === 'number' ? n.toLocaleString('th-TH') : n);

export function OligioCalModal({ onClose, onSend }) {
  const [oligioShots, setOligioShots] = useState(300);
  const [ufShots, setUfShots] = useState(400);
  const [sending, setSending] = useState(false);
  const [copied, setCopied] = useState(false);

  const oligioNormal = OLIGIO_NORMAL[oligioShots] ?? 0;
  const oligioBundle = OLIGIO_BUNDLE[oligioShots] ?? 0;
  const ufPrice = ULTRA_BASE[ufShots] ?? 0;
  const totalBundle = (oligioBundle && ufPrice) ? oligioBundle + ufPrice : 0;

  const summaryText = [
    "รายละเอียดการคำนวณราคา Oligio [Bundle Price] นะคะ",
    "",
    "กรณีที่ 1",
    "หากคุณลูกค้าซื้อ Oligio อย่างเดียว",
    `Oligio ${oligioShots} shots อย่างเดียว ราคาอยู่ที่ ${baht(oligioNormal)} บาท ค่ะ`,
    "",
    "กรณีที่ 2",
    "หากคุณลูกค้าซื้อ Oligio คู่ Ultraformer",
    "",
    `Oligio ${oligioShots} shots ราคาพิเศษ (Bundle เมื่อซื้อคู่ Ultraformer) จะอยู่ที่ ${baht(oligioBundle)} บาท`,
    "",
    `Ultraformer 3 - ${ufShots} shots จะอยู่ที่ ${baht(ufPrice)} บาท`,
    "",
    `รวม Oligio ${oligioShots} shots + Ultraformer ${ufShots} shots อยู่ที่ ${baht(totalBundle)} บาท ค่ะ`,
    "",
    `โดยคุณลูกค้าสามารถเก็บ Ultraformer III ไว้ใช้ได้โดยไม่ต้องทำทันทีนะคะ`,
  ].join('\n');

  const oligioOptions = Array.from(
    new Set([...Object.keys(OLIGIO_NORMAL), ...Object.keys(OLIGIO_BUNDLE)]).values()
  ).map(n => Number(n)).sort((a, b) => a - b);

  const ufOptions = Object.keys(ULTRA_BASE).map(n => Number(n)).sort((a, b) => a - b);

  return (
    <div className="fixed inset-0 z-[80] bg-black/50 flex items-center justify-center">
      <div className="bg-white w-[94vw] max-w-[880px] rounded-2xl p-5 border border-gray-200 shadow-xl">
        {/* Header */}
        <div className="flex items-start justify-between">
          <div>
            <div className="text-sm font-semibold text-gray-900">Oligio Bundle Calculator</div>
            <div className="text-xs text-gray-500">เลือกช็อต Oligio และ Ultraformer เพื่อสรุปราคา</div>
          </div>
          <button
            onClick={onClose}
            className="px-2 py-1 text-xs rounded-full border border-gray-300 bg-gray-50 hover:bg-gray-100 text-gray-700"
          >
            ✕ Close
          </button>
        </div>

        {/* Controls */}
        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="border rounded-xl p-4 bg-gray-50">
            <div className="text-sm font-medium text-gray-900 mb-2">เลือกจำนวนช็อต Oligio</div>
            <select
              className="w-full border rounded-lg px-3 py-2 text-sm bg-white"
              value={oligioShots}
              onChange={(e) => setOligioShots(Number(e.target.value))}
            >
              {oligioOptions.map(s => (
                <option key={s} value={s}>
                  {s} shots — ปกติ {baht(OLIGIO_NORMAL[s] ?? 0)} บาท / Bundle {baht(OLIGIO_BUNDLE[s] ?? 0)} บาท
                </option>
              ))}
            </select>

            <div className="mt-3 text-xs text-gray-600 space-y-1">
              <div>ราคาปกติ: <span className="font-medium">{baht(oligioNormal)}</span> บาท</div>
              <div>Bundle เมื่อซื้อคู่ Ultraformer: <span className="font-medium">{baht(oligioBundle)}</span> บาท</div>
            </div>
          </div>

          <div className="border rounded-xl p-4 bg-gray-50">
            <div className="text-sm font-medium text-gray-900 mb-2">เลือกจำนวนช็อต Ultraformer</div>
            <select
              className="w-full border rounded-lg px-3 py-2 text-sm bg-white"
              value={ufShots}
              onChange={(e) => setUfShots(Number(e.target.value))}
            >
              {ufOptions.map(s => (
                <option key={s} value={s}>
                  {s} shots — {baht(ULTRA_BASE[s])} บาท
                </option>
              ))}
            </select>

            <div className="mt-3 text-xs text-gray-600">
              ราคาที่ใช้คำนวณ: <span className="font-medium">{baht(ufPrice)} บาท</span>
            </div>
          </div>
        </div>

        {/* Summary */}
        <div className="mt-5">
          <div className="text-xs text-gray-500">สรุปข้อความ:</div>
          <div className="mt-2 text-sm text-gray-900 whitespace-pre-line border border-gray-200 rounded-xl p-3 bg-white">
            {summaryText}
          </div>
        </div>

        {/* Actions */}
        <div className="mt-5 flex items-center justify-end gap-3">
          <button
            onClick={async () => {
              await navigator.clipboard.writeText(summaryText);
              setCopied(true);
              setTimeout(() => setCopied(false), 1200);
            }}
            className="px-4 py-1 text-sm rounded-full border border-gray-300 text-gray-700 hover:bg-gray-100"
          >
            Copy
          </button>
          <button
            onClick={async () => {
              if (!onSend) return;
              try {
                setSending(true);
                await onSend(summaryText);
                onClose && onClose(); // ปิดโมดัลหลังส่งสำเร็จ
              } finally {
                setSending(false);
              }
            }}
            disabled={sending}
            className={`px-4 py-1 text-sm rounded-full ${sending ? 'bg-gray-300 text-white cursor-not-allowed' : 'bg-black text-white hover:opacity-90'}`}
          >
            {sending ? 'Sending…' : 'Send'}
          </button>
        </div>
      </div>

      {/* Inline toast ในโมดัล (สำหรับ Copy) */}
      {copied && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="bg-white shadow-xl rounded-xl px-4 py-2 border border-gray-200 text-sm text-gray-800">
            คัดลอกข้อความสำเร็จ
          </div>
        </div>
      )}
    </div>
  );
}
